import { environment } from '../environments/environment';

const SITE_ENVIRONMENT = environment.environment;
const ANO_BASE = SITE_ENVIRONMENT === 'pro' ? 2025 : 2024;

export function getAnoDeclaracao(anoInicio: number = ANO_BASE) {
  const anoAtual = new Date().getFullYear();
  return Array.from({ length: anoAtual - anoInicio + 1 }, (_, i) => {
    const year = anoAtual - i;
    return { label: year.toString(), value: year.toString() };
  });
}

export function getMesDeclaracao(ano: number | string) {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const months = ano.toString() === currentYear.toString() ? currentMonth : 12;
  return Array.from({ length: months }, (_, i) => i + 1);
}
